var e={S1:"0.4rem",S2:"0.8rem",S3:"1.2rem",S4:"1.6rem",M1:"2.4rem",M2:"3.2rem",M3:"4.0rem",L1:"4.8rem",L2:"5.6rem",L3:"6.4rem",L4:"7.2rem"};export{e as default};
